export const SET_SUBMISSION_REQUESTS = 'amdashboard/SET_SUBMISSION_REQUESTS';
export const SET_PAGINATION_META = 'amdashboard/SET_PAGINATION_META';
export const SET_AM_FILTER = 'amdashboard/SET_AM_FILTER';
export const SET_ORGANISATION_CLIENTS = 'amdashboard/SET_ORGANISATION_CLIENTS';
export const SET_SYNCING_SUBMISSIONS = 'amdashboard/SET_SYNCING_SUBMISSIONS';
export const ADD_SUBMISSION_TO_SUBMISSION_REQUEST =
  'amdashboard/ADD_SUBMISSION_TO_SUBMISSION_REQUEST';
